// Single source of truth for the pricing A/B test's "which pricing does this viewer see?" rule.
//
// The branch order is deliberate and load-bearing: decide on user PRESENCE first, then on
// cohort. Anonymous visitors and null-cohort users deliberately land on OPPOSITE sides:
//
//   viewer                         | pricing
//   -------------------------------|--------
//   anonymous (no user at all)     | v2      ← show v2 wherever v2 packages exist
//   logged in, cohort "test"       | v2
//   logged in, cohort "control"    | legacy
//   logged in, cohort null         | legacy  ← existing/unconfirmed user retains legacy
//
// The null-cohort rule comes from _auth+/confirm.tsx: a null cohort means an
// existing/unconfirmed user who must keep legacy pricing. That is why we must NOT collapse
// this to `user?.PricingCohort === "test"` — that expression would lump anonymous visitors
// in with the control/null cohorts and wrongly show them legacy pricing.
export function showV2Pricing(user: { PricingCohort?: string | null } | null | undefined): boolean {
  // No user at all → anonymous visitor → v2.
  if (!user) return true
  // Logged in → only the "test" cohort sees v2; "control" and null keep legacy.
  return user.PricingCohort === "test"
}
